export {
  getLocale,
  setLocale,
  locales,
  baseLocale,
  isLocale,
  localizeUrl,
  deLocalizeUrl,
  localizeHref,
  deLocalizeHref,
} from "~/paraglide/runtime";

export const SUPPORTED_LOCALES = [
  "en",
  "de",
  "fr",
  "es",
  "it",
  "nl",
  "pl",
  "fi",
  "da",
  "sv",
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE = "en" as const;

export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pl: "Polski",
  fi: "Suomi",
  da: "Dansk",
  sv: "Svenska",
};
